<template>
  <div class="dea-laboratory-question">
    <Links
      :icon="accordionArrow"
      class="dea-links--small dea-links--color-magenta-formazione"
      @click.stop="toggleAccordion"
      >{{ label }}</Links
    >
    <InputText
      :id="`question-${id}`"
      v-model="question"
      :style="`display: ${accordionDisplay}`"
      type="textarea"
      :placeholder="placeholder"
      icon
      message
      label
    ></InputText>
    <Checkbox :id="`anonymous-${id}`" v-model="anonymous" :style="`display: ${accordionDisplay}`">{{
      anonymousLabel
    }}</Checkbox>
  </div>
</template>

<script>
import Checkbox from "@/components/elements/Checkbox";
import Links from "@/components/elements/Links";
import InputText from "@/components/elements/InputText";

export default {
  name: "LaboratoryQuestion",
  components: {
    Checkbox,
    Links,
    InputText,
  },
  props: {
    label: {
      type: String,
      default: "Hai una domanda per il relatore?",
    },
    placeholder: {
      type: String,
      default: "La tua domanda",
    },
    anonymousLabel: {
      type: String,
      default: "Voglio che la mia domanda venga lasciata in anonimo.",
    },
    value: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      accordionDisplay: "none",
      accordionArrow: "freccia-right",
      returnValue: {
        text: "",
        anonymous: false,
      },
    };
  },
  computed: {
    question: {
      set(event) {
        this.returnValue.text = event.target.value;
        this.$emit("input", this.returnValue);
      },
      get() {
        return this.value;
      },
    },
    anonymous: {
      set(event) {
        this.returnValue.anonymous = event.target.checked;
        this.$emit("input", this.returnValue);
      },
      get() {
        return false;
      },
    },
  },
  methods: {
    toggleAccordion() {
      this.accordionDisplay = this.accordionDisplay === "block" ? "none" : "block";
      this.accordionArrow = this.accordionArrow === "freccia-down" ? "freccia-right" : "freccia-down";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/system.utils";

.dea-laboratory-question {
  margin-top: -$space-x-small;
  padding-bottom: $space-small;

  p {
    margin: 0;
  }

  .dea-input {
    display: none;
    margin-top: 0 !important; // sass-lint:disable-line no-important
    width: 100%;
  }

  .dea-checkbox {
    display: none;
  }
}
</style>
